(function(){
	'use strict';
	angular.module('app.setup')
		.controller('valueStream', valueStream);
	valueStream.$inject = ['$rootScope', '$scope', '$timeout', '$uibModal', '$translate', 'leanFilterService', 'tableRenderService', 'tableService', 'valueStreamService', 'storeService'];

	function valueStream($rootScope, $scope, $timeout, $uibModal, $translate, leanFilterService, tableRenderService, tableService, valueStreamService, storeService) {

		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		var reportSettingsName = 'ViewValueStream';
		// Extra query params to send to backend in data requests
		var extraParams = [{}];
		var rendererParams = {};

		$scope.filterService = leanFilterService;
	
		vm.useSiteSwitcher = true;
		vm.showExcel = false;
		vm.isAdmin = $rootScope.authz.isAdmin();
		vm.showAddValueStream = vm.isAdmin;
		vm.addValueStream = addValueStream;
		vm.deleteValueStream = deleteValueStream;
		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.reportName = 'Value Streams';

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams).then(function (response) {
				// If any data manipulation is needed, do it here
				return response;
			});
		}

		init();

		var columns = [
			{
				'id': 'name',
				'display': 'Value Stream Name',
				'renderer': tableRenderService.inlineEditWithoutTooltip,
				'deleteFunction': 'deleteValueStream',
				'requiredPermission': 'adminOrUser',
				'width': 400,
				'show': true
			},
			{
				'id': 'personName',
				'display': 'Responsible',
				'renderer': tableRenderService.inlineEditList,
				'width': 300,
				'show': true
			},
			{
				'id': 'activated',
				'display': 'Performance Management Activated',
				'renderer': tableRenderService.inlineEditList,
				'isYesNo': true,
				'width': 225,
				'show': true
			}
		];

		var meta = {
			reportSettingsName: reportSettingsName,
			reportName: vm.reportName,
			reportUrl: adminConfig.factory.id + '/FactoryValueStreams',
			noPaging: true,
			columns: columns,
			pinnedColumns: [],
			defaultSort: 'name',
			defaultSortDirection: 'asc',
			extraParams: extraParams,
			rendererParams: rendererParams,
			hideSearch: true,
			isGlobalReportSetting:true
		};

		function addValueStream() {
			var valueStreamFormScope = $scope.$new();
			var opts = {
				scope: valueStreamFormScope,
				templateUrl: '/application/f/setup/factory/general/value-stream-form.html',
				size: 'sm',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);

			valueStreamFormScope.closeDialog = function() {
				instance.close();
				valueStreamFormScope.$destroy();
			};

			valueStreamFormScope.result = function(message, isSuccessful) {
				$rootScope.$emit('toast', {'message': message, 'success': isSuccessful});
				if (isSuccessful) {
					$scope.$broadcast('reloadTable');
				}
				instance.close();
				valueStreamFormScope.$destroy();
			};
		}

		function deleteValueStream(valueStreamNdx) {
			valueStreamService.getValueStreamDependencyCount(valueStreamNdx, adminConfig.factory.id)
				.then(function(response) {
					var translatedParts = [];
					var englishParts = [];
					function addDetail(count, oneKey, otherKey, oneText, otherText, separator) {
						if (!(count > 0)) {
							return;
						}
						var translated = $translate.instant(count === 1 ? oneKey : otherKey, { count: count });
						var english = count + ' ' + (count === 1 ? oneText : otherText);
						if (translatedParts.length) {
							translatedParts[translatedParts.length - 1] += separator;
							englishParts[englishParts.length - 1] += separator;
						}
						translatedParts.push(translated);
						englishParts.push(english);
					}
					if (response && response.ndx) {
						addDetail(response.metricTargets, 'modal.confirm.valueStream.metricTarget_one', 'modal.confirm.valueStream.metricTarget_other', 'metric target entry', 'metric target entries', ', ');
						addDetail(response.metricResults, 'modal.confirm.valueStream.metricResult_one', 'modal.confirm.valueStream.metricResult_other', 'metric result entry', 'metric result entries', ', ');
						addDetail(response.params, 'modal.confirm.valueStream.reportCardParameter_one', 'modal.confirm.valueStream.reportCardParameter_other', 'value stream report card parameter entry', 'value stream report card parameter entries', ' and ');
					}
					var confirmScope = $scope.$new();
					confirmScope.valueStreamNdx = valueStreamNdx;
					confirmScope.buttonText = 'Delete';
					if (translatedParts.length) {
						var details = translatedParts.join('');
						confirmScope.messageKey = 'modal.confirm.deleteValueStreamWithDetails';
						confirmScope.messageValues = { details: details };
						confirmScope.fallbackText = 'There are ' + englishParts.join('') + ' recorded against this value stream. Are you sure you want to delete this value stream? All associated data will be deleted if you perform this action.';
					} else {
						confirmScope.additionalText = 'delete this value stream';
					}

					var opts = {
						scope: confirmScope,
						templateUrl: '/application/f/core/confirm.html'
					};

					var instance = $uibModal.open(opts);
					confirmScope.closeDialog = function() {
						instance.close();
						confirmScope.$destroy();
					};

					confirmScope.yes = function() {
						var valueStreamNdx = confirmScope.valueStreamNdx;
						instance.close();
						confirmScope.$destroy();
						valueStreamService.deleteValueStream(valueStreamNdx, adminConfig.factory.id).then(function(message) {
							var isSuccessful = (message == 'Value stream deleted successfully');
							$rootScope.$emit('toast', {'message': message, 'success': isSuccessful});
							if (isSuccessful) {
								$scope.$broadcast('reloadTable');
							}
						});
					};
				});
		}

		function init() {
			$scope.filterService.clearFilters();
		}
	}
})();